export default {
    setStart(state, start) {
        state.start = start;
    },
    setPing(state, ping) {
        state.ping = ping;
    },
    setReturnUrl(state, returnUrl) {
        state.returnUrl = returnUrl;
    },
    setLoginState(state, loginState) {
        state.loginState = loginState;
    },
    isStarting(state, isStarting) {
        state.isStarting = isStarting;
    },
    
}